// Copyright (c) Docugami, Inc. All rights reserved.

import { mergeStyleSets } from "@fluentui/react";

export const graphPickerClassNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px',
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden',
            },
        },
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '16px',
        maxWidth: '16px',
    },
    modalScrollableContent: {
        width: "100%",
        height: "100%",
        minHeight: "500px",
        overflow: "hidden"
    },
    modalRoot: {
        maxWidth: "75%",
        minWidth: "1000px",
        height: "content",
        maxHeight: "60%",
        borderRadius: "10px",
    }
});
